import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M41.182 9a3.818 3.818 0 0 0-3.818 3.818v22.364a3.818 3.818 0 0 0 7.636 0V12.818A3.818 3.818 0 0 0 41.182 9ZM25.91 20.319a3.818 3.818 0 0 1 7.636 0v14.864a3.818 3.818 0 0 1-7.636 0V20.32ZM18.272 24a3.818 3.818 0 0 0-3.818 3.819v7.364a3.818 3.818 0 0 0 7.636 0v-7.364A3.818 3.818 0 0 0 18.272 24ZM6.75 31.5a3.75 3.75 0 0 0 0 7.501h.136a3.75 3.75 0 0 0 0-7.5H6.75Z",
      clipRule: "evenodd"
    }
  )
);
var SvgNetwork4Outlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var Network4Outlined_default = SvgNetwork4Outlined;

export { Network4Outlined_default as default };
